<div class="header">
  <a [attr.href]="eStockHomePage" class="header-logo">
    <img src="assets/logo.png" alt="Logo" />
  </a>
  <div class="header-right">
    <a href="https://t.me/mpu_support_bot" class="header-title">Допомога</a>
    <a class="header-title" (click)="logout()">Вихід</a>
  </div>
</div>
